// extracted by mini-css-extract-plugin
export default {"mobileNavContainer":"MobilNav_mobileNavContainer__8ZyxY","mobileNavLink":"MobilNav_mobileNavLink__1GkF3"};